import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";

import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import Select from "react-select";
import Validation from "../../../common/FormValidation";
import { CancelButton, SaveButton } from "../../../common/Button";

import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";

library.add(fas);

const EditOffCanvance = (props) => {
  const { postData, getData } = useContext(Context);

  const id = props.show;
  const [data, setData] = useState();

  const [formData, setFormData] = useState({
    employee_id: "",
    requestor_name: "",
    title: "",
    description: "",
    priority_id: "",
    channel_id: "",
  });

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [employee, setEmployees] = useState([]);
  const [channel, setChannels] = useState([]);
  const [priority, setPrioritys] = useState([]);

  const handleChange = (e) => {
    if (
      e?.name === "channel_id" ||
      e?.name === "priority_id" ||
      e?.name === "employee_id"
    ) {
      setFormData({ ...formData, [e.name]: e });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = Validation.FormValidation({
      classname: ".ticketgenerateclass",
    });

    if (validationErrors) {
      try {
        const response = await postData(
          `/ticket_management/ticket_generates/${id}`,
          formData
        );

        if (response.success) {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        } else {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const GetEditData = async () => {
    const response = await getData(`/ticket_management/ticket_generates/${id}`);
    setData(response);
    setFormData(response?.data);

    const res = await getData("/masters/allusers");
    const option = [];
    if (res.success) {
      res?.data?.map((data) => {
        option.push({
          value: data.userid,
          name: "employee_id",
          label: data.user.name,
        });
      });
    }
    setEmployees(option);

    const res2 = await getData("/masters/all-channel");
    setChannels(res2.data);

    const res3 = await getData("/masters/all-priority");
    setPrioritys(res3.data);
  };

  useEffect(() => {
    GetEditData();
  }, []);

  const errorStyle = {
    color: "red",
    marginLeft: "5px",
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Edit Ticket Generates</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Edit Generate Ticket</Card.Title>
              <hr />
              <Container>
                <Row>
                  <Col md={12}>
                    <Container>
                      <Row className="">
                        <Col xxl={12} xl={12} md={10}>
                          <Form
                            onSubmit={handleSubmit}
                            role="form"
                            className="ticketgenerateclass"
                          >
                            <Row>
                              <Col
                                lg={12}
                                md={12}
                                className=" mx-auto Add-content"
                              >
                                <Row>
                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Select Requestor Type
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Check
                                            inline
                                            label="Client"
                                            value={"Client"}
                                            name="requestor_type"
                                            type="radio"
                                            checked={
                                              formData?.requestor_type ===
                                              "Client"
                                                ? true
                                                : false
                                            }
                                            onClick={handleChange}
                                          />
                                          <Form.Check
                                            inline
                                            label="Employee"
                                            value={"Employee"}
                                            name="requestor_type"
                                            onClick={handleChange}
                                            type="radio"
                                            checked={
                                              formData?.requestor_type ===
                                              "Employee"
                                                ? true
                                                : false
                                            }
                                          />
                                        </Col>
                                        <span className="error-message"></span>
                                      </Row>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Requestor Name
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                name="requestor_name"
                                                value={formData?.requestor_name}
                                                onChange={handleChange}
                                                placeholder="Requestor Name"
                                                id="inputEmail3"
                                                className="input-mandatory"
                                              />
                                            </InputGroup>
                                            <span className="error-message"></span>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>

                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Employee
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Select
                                            placeholder="Select Employee"
                                            className="custom-select"
                                            name="employee_id"
                                            value={formData?.employee_id}
                                            onChange={handleChange}
                                            options={employee}
                                          />
                                          <span className="error-message"></span>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>

                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Title
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                name="title"
                                                value={formData.title}
                                                onChange={handleChange}
                                                placeholder="Ticket Generates"
                                                id="inputEmail3"
                                                className="input-mandatory"
                                              />
                                            </InputGroup>
                                            <span className="error-message"></span>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>

                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Description
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                name="description"
                                                value={formData.description}
                                                onChange={handleChange}
                                                placeholder="description"
                                                id="inputEmail3"
                                                className="input-mandatory"
                                              />
                                            </InputGroup>
                                            <span className="error-message"></span>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>

                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Priority
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Select
                                            placeholder="Select Priority"
                                            className="custom-select"
                                            name="priority_id"
                                            value={formData?.priority_id}
                                            onChange={handleChange}
                                            options={priority}
                                          />
                                          <span className="error-message"></span>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>

                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Chanel
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Select
                                            placeholder="Select Chanel"
                                            className="custom-select"
                                            name="channel_id"
                                            value={formData?.channel_id}
                                            onChange={handleChange}
                                            options={channel}
                                          />

                                          <span className="error-message"></span>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>

                                <Row className="mt-5 pb-3">
                                  <div className="d-flex justify-content-center">
                                    <Link>
                                      <CancelButton
                                        name={"cancel"}
                                        handleClose={props.handleClose}
                                      />
                                    </Link>
                                    <SaveButton
                                      name={"save"}
                                      handleSubmit={handleSubmit}
                                    />
                                  </div>
                                </Row>
                              </Col>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};
export default EditOffCanvance;
